import * as React from 'react';
import { InteractionReportBlock, PVAPage, PVABadge, LoadingIndicatorMini, PVAUserSelect, LoadingIndicator } from '../../../components';
import { BaseRouteProps } from '../../../interfaces';
import { FilterStore, UserStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { ReportDataService } from '../../../services';
import './InteractionReport.css';

interface MyInteractionReportProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
}

@inject('FilterStore', 'UserStore') @observer
export class MyInteractionReport extends React.Component<MyInteractionReportProps, { miniLoader: boolean, pdfLoader: boolean, fetchedOrgId: number, fetchedSurveyId: number, fetchedSurveyVersionId: number }> {
    private reportDataService = new ReportDataService(this.props.notificationService);

    constructor(props: MyInteractionReportProps) {
        super(props);

        this.state = {
            miniLoader: false,
            pdfLoader: false,
            fetchedOrgId: 0,
            fetchedSurveyId: 0,
            fetchedSurveyVersionId: 0
        };
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get userId() {
        if (this.props.FilterStore && this.props.FilterStore.interactionReportUserId) {
            return this.props.FilterStore.interactionReportUserId;
        }
        return this.props.UserStore!.userInfo.id;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    @computed get selectedUserData() {
        return this.props.FilterStore!.interactionReportUserData;
    }

    private updateSurvey() {
        if (!this.surveyVersion) {
            this.setState({
                miniLoader: false
            });
            return;
        }

        const userId = this.userId;

        if (userId) {
            this.setState({ miniLoader: true });
            this.reportDataService.getManagersReportData(this.surveyVersion.id, userId).then((reportData) => {
                this.props.FilterStore!.interactionReportUserData = reportData;
                this.setState({
                    miniLoader: false
                });
            }).catch(() => {
                this.setState({
                    miniLoader: false
                });
            });
        } else {
            this.props.FilterStore!.interactionReportUserData = null;
            this.setState({
                miniLoader: false
            });
        }
    }

    private update() {
        const orgId = (this.props.FilterStore && this.props.FilterStore.organization) ? this.props.FilterStore.organization.id : 0;
        const surveyId = (this.props.FilterStore && this.props.FilterStore.survey) ? this.props.FilterStore.survey.id : 0;
        const surveyVersionId = (this.props.FilterStore && this.props.FilterStore.surveyVersion) ? this.props.FilterStore.surveyVersion.id : 0;

        const filtersChanged = (orgId !== 0 && orgId !== this.state.fetchedOrgId) ||
                               (surveyId !== 0 && surveyId !== this.state.fetchedSurveyId) ||
                               (surveyVersionId !== 0 && surveyVersionId !== this.state.fetchedSurveyVersionId);

        const currentUserId = this.props.UserStore!.userInfo.id;
        if (this.props.FilterStore!.interactionReportUserId !== currentUserId) {
            this.props.FilterStore!.interactionReportUserId = currentUserId;
            this.setState({
                fetchedOrgId: orgId,
                fetchedSurveyId: surveyId,
                fetchedSurveyVersionId: surveyVersionId
            });
            this.updateSurvey();
        } else if (filtersChanged || (!this.selectedUserData && !this.state.miniLoader)) {
            this.setState({
                fetchedOrgId: orgId,
                fetchedSurveyId: surveyId,
                fetchedSurveyVersionId: surveyVersionId
            });
            this.updateSurvey();
        }
    }

    public userChange(e: any) {
        const userId: number = Number(e.target.value);
        this.props.FilterStore!.interactionReportUserId = userId;
        this.props.FilterStore!.interactionReportUserData = null;
        this.updateSurvey();
    }

    private exportPDF() {
        if (this.selectedUserData && this.surveyVersion && this.userId) {
            this.setState({
                pdfLoader: true
            });
            this.reportDataService.getManagerReportDataPDF(this.surveyVersion.id, this.userId, 'InteractionReport', this.surveyReportType ? this.surveyReportType.id : undefined)
                .then(
                    (reportData: any) => {
                        this.setState(
                            {
                                pdfLoader: false
                            });
                    }, (err: any) => {
                        this.setState(
                            {
                                pdfLoader: false
                            });
                    });
        }
    }


    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    public render() {
        const defaultOptions = [{
            id: 0,
            value: '- Clear Selected -'
        }];
        
        const selector = <PVAUserSelect defaultOptions={defaultOptions} options={this.users} selected={this.userId} onChange={(e: any) => this.userChange(e)} />;

        const actions = [
            {
                header: 'Export Options',
                items: [
                    {
                        id: 'pdf-export',
                        name: 'PDF Export',
                        callback: () => this.exportPDF(),
                        icon: 'Icon awesome-file-pdf.svg'
                    }
                ]
            }
        ];

        return <PVAPage>
            <PVAPage.Header actions={actions}>
                <PVAPage.Header.Title>
                    <PVAPage.Header.Title.Text>
                        <span><span className="greyDark">My PVA Interaction Report<span className="trademark">TM</span> for: </span>{this.selectedUserData ? this.selectedUserData.name : <LoadingIndicatorMini/>}</span>
                    </PVAPage.Header.Title.Text>
                </PVAPage.Header.Title>
            </PVAPage.Header>
            <PVAPage.Body>
                {(this.state.pdfLoader) && <LoadingIndicator showPdfDescription={this.state.pdfLoader} showBackground={true} showInPanel={true} />}
                {(this.state.miniLoader) && <LoadingIndicator />}
                {!this.state.pdfLoader && !this.state.miniLoader && (
                    <InteractionReportBlock history={this.props.history} match={this.props.match} location={this.props.location} notificationService={this.props.notificationService} FilterStore={this.props.FilterStore} />
                )}
            </PVAPage.Body>
            {!this.state.pdfLoader && !this.state.miniLoader && <PVAPage.Footer />}
        </PVAPage>;
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/interaction/MyInteractionReport.tsx